/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { Colors, Typography } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { COLOR_KEYS, MEDIA_MIN_WIDTH } from '../../../constants';
import { Group, GroupProps } from './Group';

export interface ResourcesSectionProps {
  backgroundColor:
    | typeof COLOR_KEYS.blue10
    | typeof COLOR_KEYS.cream
    | typeof COLOR_KEYS.neutral100
    | typeof COLOR_KEYS.neutral200;
  heading: string;
  groups: GroupProps[];
}

const Styles = labelStyles('ResourcesSection', {
  root: (backgroundColor: ResourcesSectionProps['backgroundColor']) =>
    css({
      padding: '64px 20px',
      backgroundColor: Colors[backgroundColor],

      [MEDIA_MIN_WIDTH.small]: {
        padding: '72px 20px',
      },

      [MEDIA_MIN_WIDTH.large]: {
        padding: '108px 20px',
      },
    }),

  heading: css({
    ...Typography.pageHeader7,
    color: Colors.earth,
    textAlign: 'center',
    marginBottom: '32px',

    [MEDIA_MIN_WIDTH.large]: {
      marginBottom: '48px',
    },

    [MEDIA_MIN_WIDTH.large]: {
      ...Typography.pageHeader5,
      marginBottom: '64px',
    },
  }),

  groups: css({
    maxWidth: '1170px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '30px',

    [MEDIA_MIN_WIDTH.large]: {
      gridTemplateColumns: '1fr 1fr',
    },
  }),
});

export function ResourcesSection(props: ResourcesSectionProps) {
  return (
    <div css={Styles.root(props.backgroundColor)}>
      <h2 css={Styles.heading}>{props.heading}</h2>
      <div css={Styles.groups}>
        {props.groups.map((group) => (
          <Group {...group} key={group.heading} />
        ))}
      </div>
    </div>
  );
}
